import React from 'react';
import { Tag } from 'antd';
import BindTitle from '../BindTitle/BindTitle';
import BindsRow from '../BindsRow/BindsRow';
import Bind from '../Bind/Bind';
import { getValueByPath } from '../../../../../../helpers/getValueByPath';
import styles from './HouseBinds.module.scss';

const HouseBinds = ({ binds }) => {
  return (
    <div>
      <BindTitle>Дома</BindTitle>
      <BindsRow size="lg">
        {binds.map((bind) => (
          <Tag key={bind.streetName} className={styles.container}>
            {bind.streetName}
            <BindsRow size="md" className={styles.row}>
              {bind.houses.map((houseBind) => (
                <Bind
                  key={houseBind.id}
                  color="#4072b1"
                  item={houseBind}
                  content={getValueByPath(houseBind, 'house.fullName')}
                  small
                />
              ))}
            </BindsRow>
          </Tag>
        ))}
      </BindsRow>
    </div>
  );
};

export default HouseBinds;
